import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Modal from "@pathwright/ui/src/components/modal/Modal"
import { Box, VStack } from "@chakra-ui/react"
import ConfirmDangerousActionForm from "@pathwright/ux/src/components/form/ConfirmDangerousActionForm"
import {
  GroupFragment,
  RegistrationFragment,
  ResourceFragment
} from "@pathwright/graphql-client/src/generated"

type ConfirmRemovalProps = {
  registration: RegistrationFragment
  cohort: GroupFragment
  resource: ResourceFragment
  onCancel: () => void
  onRemove: () => Promise<any>
}

const RegistrationRemove = ({
  registration,
  cohort,
  resource,
  onCancel,
  onRemove
}: ConfirmRemovalProps) => {
  const { t } = useTranslate()
  const isCollection = resource?.resource_type === 30
  const tPrefix = isCollection
    ? "cohort.member.actions.remove_from_collection"
    : "cohort.member.actions.remove"

  const userFirstName = registration.user.first_name

  return (
    <Modal onClose={onCancel}>
      <VStack h="100%" justifyContent="center" pointerEvents="none">
        <Box pointerEvents="auto" bg="white" borderRadius="20px">
          <ConfirmDangerousActionForm
            confirmValue={userFirstName}
            tConfirmLabel={({ label }) =>
              t(`${tPrefix}.confirm_prompt`, {
                user: label
              })
            }
            onSubmit={onRemove}
            onCancel={onCancel}
          >
            {({ formAction }) => (
              <BlankSlate
                layer="overlay"
                icons={null}
                icon="caution-triangle"
                heading={t(`${tPrefix}.heading`, {
                  user: userFirstName,
                  // Cohort may be source cohort, in which case there will be no name,
                  // so use resource name instead.
                  cohort: cohort?.name || resource?.name
                })}
                body={t(`${tPrefix}.body`, {
                  user: userFirstName
                })}
                preActionContent={formAction}
                stack
              />
            )}
          </ConfirmDangerousActionForm>
        </Box>
      </VStack>
    </Modal>
  )
}

export default RegistrationRemove
